<template>
    <div>
        test
    </div>
</template>

<script>
    export default {
        name: "Test",
        mounted() {
            let beforeDate=new Date().toISOString().split('.')[0];
            console.log(111, beforeDate);
            let author = "lemooljiang";
            this.steem.api.getDiscussionsByAuthorBeforeDate(author, null, beforeDate, 10, function(err, result) {
                console.log(567, err, result);

            });
        }
    }
</script>

<style scoped>

</style>
